import { Grid } from '@mui/material';
import React, { useEffect, useState } from 'react';
import PostToAccountFormView from '../../../components/account/create/post_to_ac/PostToAccountFormView';
import PostToAccountListView from '../../../components/account/create/post_to_ac/PostToAccountListView';
import { MahasulListDetailsProps } from '../../../helpers/models/Models';
import MemberSearchView from '../../../components/account/create/unit_correction/MemberSearchView';
import ManageUnitListView from '../../../components/account/create/unit_correction/ManageUnitListView';
import useFetchSubData from '../../../helpers/useSubFetch';
import AppURL from '../../../constants/AppURL';

const ManageUnitCorrectionView = () => {
    const [onMahasulList, setOnMahasulList] = useState<MahasulListDetailsProps[] | null>(null);
    const [onSearchMem, setOnSearchMem] = useState("");
    const [onMemberSN, setMemberSN] = useState("");
    const {
        data: member_data
    } = useFetchSubData(
        `${AppURL.ApplicationURL}app/all/member/search/report/list/?search=${onSearchMem}`,
        onSearchMem
    );
    const refetch = async (memberSN: any) => {
        if (!memberSN) return;

        try {
            const res = await fetch(
                `${AppURL.AccountURL}account/one/member/reading/details/view/?member_sn=${memberSN}`
            );
            const data = await res.json();
            if (data?.status === 200) {
                setOnMahasulList(data);
            }
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(()=>{
        refetch(onMemberSN);
    },[onMemberSN])
    return (
        <Grid container spacing={2}>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <MemberSearchView setMemberSN={setMemberSN} refetch={refetch} member_data={member_data} setOnSearchMem={setOnSearchMem} />
            </Grid>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <ManageUnitListView refetch={refetch} onMahasulList={onMahasulList} />
            </Grid>
        </Grid>
    )
}

export default ManageUnitCorrectionView